limitMax.$inject = [];

function limitMax() {
    return {
        link: function (scope, element, attrs) {
            element.on("keydown keyup", function (e) {
                if (Number(element.val()) > Number(attrs.max) &&
                    e.keyCode != 46 // delete
                    &&
                    e.keyCode != 8 // backspace
                ) {
                    e.preventDefault();
                    element.val(attrs.max);
                }
            });
        }
    };
}
module.exports = ngModule => {
    ngModule.directive('limitMax', limitMax);
};

